export default __webpack_public_path__ + "locales/pt-BR/MainBar.json?hash=1ae58ade0da6e9a3357c978ab8a786c4";